import { render, staticRenderFns } from "./ChargerLinksMenu.vue?vue&type=template&id=8c1226a8&lang=pug&"
import script from "./ChargerLinksMenu.vue?vue&type=script&lang=ts&"
export * from "./ChargerLinksMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports